export default __webpack_public_path__ + "static/media/BnB.c947db42.jpg";